import useWindowSize from 'hooks/use-windowSize';

import { DocumentDownload, Briefcase, Book1, Call, Radar2 } from 'iconsax-react';


import classes from './ContentBouneses.module.scss';

const ContentBouneses = ({ contentType = 'course' }) => {
	const { desktopDevice } = useWindowSize();
	return (
		<div className={`${classes['content-bouneses-wrapper']} d-flex flex-column gap-3`}>
			<h3>Bonuses Included In This {contentType === 'course' ? 'Course' : 'Job Qualification'}</h3>
			<p>
				Get valuable resources, and ISO backed certification through our assessment of your
				knowledge and access global jobs only for Pharmuni alumni.
			</p>
			{desktopDevice ? (
				<div className={`${classes['content-bouneses-desktop']}`}>
					<div>
						<div>
							<DocumentDownload size="39" color="#18BBA8" />
							<p>Downloadable Resources</p>
						</div>
						<div>
							<Briefcase size="39" color="#18BBA8" />
							<p>Access to Pharmuni Job Board</p>
						</div>
						<div>
							<Book1 size="39" color="#18BBA8" />
							<p>Exclusive Assessment Quiz</p>
						</div>
					</div>
					<div>
						<div>
							<Call size="39" color="#18BBA8" />
							<p>Customer Support</p>
						</div>
						<div>
							<DocumentDownload size="39" color="#18BBA8" />
							<p>Downloadable Certification</p>
						</div>
						<div>
							<Radar2 size="39" color="#18BBA8" />
							<p>Skill Tree Level Up</p>
						</div>
					</div>
				</div>
			) : (
				<div className={`${classes['content-bouneses-mobile']}`}>
					<div>
						<div className={`${classes['content-bouneses-cart']}`}>
							<DocumentDownload size="39" color="#18BBA8" />
							<p>Downloadable Resources</p>
						</div>
						<div className={`${classes['content-bouneses-cart']}`}>
							<Book1 size="39" color="#18BBA8" />
							<p>Exclusive Assessment Quiz</p>
						</div>
						<div className={`${classes['content-bouneses-cart']}`}>
							<Call size="39" color="#18BBA8" />
							<p>Customer Support</p>
						</div>
						<div className={`${classes['content-bouneses-cart']}`}>
							<DocumentDownload size="39" color="#18BBA8" />
							<p>Downloadable Certification</p>
						</div>
						<div className={`${classes['content-bouneses-cart']}`}>
							<Briefcase size="39" color="#18BBA8" />
							<p>Access to Pharmuni Job Board</p>
						</div>
						<div className={`${classes['content-bouneses-cart']}`}>
							<Radar2 size="39" color="#18BBA8" />
							<p>Skill Tree Level Up</p>
						</div>
					</div>

				</div>
			)}
		</div>
	);
};

export default ContentBouneses;
